<template>
	<v-container fill-height class="mx-auto">
		<v-layout row wrap align-center>
			<v-flex class="text-center">
				<v-card class="mx-auto" max-width="900" max-height="800">
					<v-row>
						<v-col
							cols="12"
							sm="6"
							align="center"
							justify="center"
							fill-height
							class="pa-10 d-none d-md-flex d-lg-flex d-xl-flex"
							:elevation="10"
							:style="{
								'background-color': this.theme.dark
									? this.theme.primary
									: this.theme.light,
							}"
						>
						</v-col>

						<v-col cols="12" md="6" class="text-left px-10 py-10 form">
							<v-main>
								<v-card-title class="pl-0">Create a new password</v-card-title>
								<v-main class="py-3 pr-4 pt-1">
									<v-card-text class="pb-4 pl-0">
										Enter the email address you used when you joined and we’ll
										send you instructions to reset your password
									</v-card-text>
									<v-card-text class="pb-10 pl-0 pt-0">
										For security reasons, we do NOT store your password. So be
										rest assured that we will never send your password via
										email.
									</v-card-text>

									<v-text-field
										name="password"
										v-model="form.password"
										label="Password"
										placeholder="Password"
										:append-icon="
											show_password ? 'visibility' : 'visibility_off'
										"
										@click:append="() => (show_password = !show_password)"
										:type="show_password ? 'password' : 'text'"
										solo
									></v-text-field>
									<v-text-field
										name="password"
										v-model="form.confirm_password"
										label="Confirm Password"
										placeholder="Confirm Password"
										:append-icon="
											show_confirm_password ? 'visibility' : 'visibility_off'
										"
										@click:append="
											() => (show_confirm_password = !show_confirm_password)
										"
										:type="show_confirm_password ? 'password' : 'text'"
										:rules="[
											v => v == this.form.password || 'Passwords don\'t match',
										]"
										@keydown.enter="complete"
										required
										solo
									></v-text-field>

									<v-row>
										<v-col>
											<v-btn
												class="white--text mt-2 text-capitalize"
												:color="theme.primary"
												:disabled="cannot_submit"
												@click="complete"
												width="210"
												depressed
											>
												Update password
											</v-btn>
										</v-col>
									</v-row>
								</v-main>
							</v-main>
						</v-col>
					</v-row>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
	name: 'ResetPassword',

	data: () => ({
		form: {
			password: '',
			confirm_password: '',
		},
		show_password: String,
		show_confirm_password: String,
	}),
	created() {
		if (this.user) this.$router.push({ name: 'Dashboard' })
	},
	methods: {
		...mapMutations(['completeLogin', 'setAlert']),
		complete() {
			this.form.token = this.$route.query.token
			if (this.form.token == null)
				return this.setAlert([
					"We can't find the token. Please click the link in your email again.",
					'info',
				])
			this.core.http
				.post('auth/complete_reset', this.form)
				.then(response => {
					this.setAlert(response)
					this.completeLogin(response.data)
					this.$router.push({ name: 'Dashboard' })
				})
				.catch(error => {
					this.setAlert(error.response)
				})
		},
	},
	computed: {
		...mapGetters(['theme', 'user', 'loading']),
		cannot_submit: function() {
			return (
				this.form.password == '' ||
				this.form.confirm_password == '' ||
				this.form.password != this.form.confirm_password
			)
		},
	},
}
</script>
